<template lang="pug">
.container-perfil
  .header
    .info-desenvolvedor
      .pessoa
        .foto-perfil
          img(:src="fotoPerfil" alt="Foto do Desenvolvedor")
        .info
          .nome {{ nomeUsuario }}
            .editar-perfil(@click="$router.push('/espaco-nexa/editar-perfil/informacoes-pessoais')")
              LucideIcon(name="Pencil" :size="20")
          .funcao
            LucideIcon(name="Briefcase" :size="16")
            | Desenvolvedor Frontend
          .localizacao
            LucideIcon(name="MapPin" :size="16")
            | Campo Grande, MS
      .descricao Desenvolvedor Frontend com experiência em JavaScript, Vue.js e HTML. Apaixonado por criar interfaces intuitivas e funcionais.
    .card-podium
      .top-3(
        v-for="(podium, idx) in podiumHabilidades"
        :key="podium.skill"
      )
        .trofeu
          LucideIcon(name="Trophy" :size="16" :color="podium.filledColor")
        Estrelas(
          :filled="podium.filled"
          :filledColor="podium.filledColor"
          :size="estrelasSize"
          useStroke
        )
        .habilidade {{ podium.skill }}
        .posicao {{ podium.posicao }}º Lugar
  .habilidades
    .label-habilidades
      LucideIcon(name="Star" :size="16" color="#b7ff00")
      | Habilidades
    BarraHabilidades(
      v-for="(hab, idx) in habilidades"
      :key="hab.skill"
      :skill="hab.skill"
      :level="hab.level"
    )
    .tags-habilidades
      Tags(:tags="tags")
  .btn-acoes-social
    .btn-social
      ButtonPadrao(variant="negative" iconOnly)
        LucideIcon(slot="icon-left" name="Github" :size="16")
      ButtonPadrao(variant="negative" iconOnly)
        LucideIcon(slot="icon-left" name="Linkedin" :size="16")
      ButtonPadrao(variant="negative" iconOnly)
        LucideIcon(slot="icon-left" name="Mail" :size="16")
    ButtonPadrao(variant="default") Contato
</template>

<script>
import Tags from '@/components/ui/Tags.vue'
import BarraHabilidades from '@/components/ui/BarraHabilidades.vue'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import Estrelas from '@/components/ui/Stars.vue'

export default {
  name: 'Perfil',
  components: {
    Tags,
    BarraHabilidades,
    ButtonPadrao,
    Estrelas
  },
  data() {
    return {
      podiumHabilidades: [
        { skill: 'JavaScript', posicao: 1, filled: 5, filledColor: '#facc15' },
        { skill: 'Vue.js', posicao: 2, filled: 4, filledColor: '#60a5fa' },
        { skill: 'HTML', posicao: 3, filled: 2, filledColor: '#f87171' }
      ],
      habilidades: [
        { skill: 'HTML', level: 'Mestre' },
        { skill: 'Node.js', level: 'Professor' },
        { skill: 'Vue.js', level: 'Profissional' },
        { skill: 'Git', level: 'Profissional' },
        { skill: 'JavaScript', level: 'Praticante' },
        { skill: 'CSS', level: 'Aprendiz' },
        { skill: 'TypeScript', level: 'Iniciando' }
      ],
      tags: [
        { id: 1, name: 'JavaScript' },
        { id: 2, name: 'Vue.js' },
        { id: 3, name: 'CSS' },
        { id: 4, name: 'HTML' },
      ],
      fotoPerfil: require('@/assets/placeholder.svg'),
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
    }
  },
  computed: {
    estrelasSize() {
      return this.windowWidth <= 390 ? 14 : 16
    },
    
    nomeUsuario() {
      try {
        const userData = localStorage.getItem('user-nexa')
        if (userData) {
          const user = JSON.parse(userData)
          return user.username || user.nome || 'Usuário'
        }
        return 'Usuário'
      } catch (error) {
        console.error('Erro ao buscar dados do usuário:', error)
        return 'Usuário'
      }
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.updateWindowWidth)
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWindowWidth)
    }
  },
  methods: {
    selecionarFoto() {
      if (this.$refs.inputFoto) this.$refs.inputFoto.click()
    },
    onFotoSelecionada(event) {
      const file = event.target.files && event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fotoPerfil = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style lang="scss">
.container-perfil {
  width: 100%;
  border: 1px solid $borderColor;
  border-radius: 8px;
  background-color: $corFundoPadraoDashboard;
  transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), box-shadow 0.25s cubic-bezier(0.4,0,0.2,1);

  &:hover {
    transform: scale(1.006);
    box-shadow: 0 5px 10px 0 #b7ff0033;
  }

  .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 0 25px;
    box-sizing: border-box;

    .info-desenvolvedor {
      display: flex;
      flex-direction: column;
      padding: 25px 0;

      .pessoa {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 10px;

        .foto-perfil {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid $corVerdeClaro;
          box-sizing: border-box;
          position: relative;
          z-index: 0;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }

          &::after {
            content: "";
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.45);
            opacity: 0;
            transition: opacity 0.2s;
            z-index: 3;
            border-radius: 50%;
            pointer-events: none;
          }
          
          &:hover{
            color: $corVerdeClaro;  
            &::after {
              opacity: 1;
            }

            .icone-camera{
              opacity: 1;
            }
          }
        }

        .info {
          display: flex;
          flex-direction: column;

          .nome {
            font-size: 20px;
            font-weight: bold;
            color: $corVerdeClaro;
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 5px;

            .editar-perfil{
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              border-radius: 100%;
              color: $corBranco;

              &:hover {
                background: $corVerdeClaroHover;
                color: $corVerdeClaro;
              }
            }
          }

          .funcao, .localizacao {
            font-size: 14px;
            color: $corValueInfoContato;
            display: flex;
            align-items: center;
            gap: 5px;
            margin-top: 5px;
          }
        }
      }

      .descricao {
        font-size: 14px;
        color: $corValueInfoContato;
      }
    }

    .card-podium{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      max-width: 800px;
      width: 100%;
      margin: 0 auto;

      .top-3 {
        padding: 15px 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: $corPreto;
        border-radius: 8px;
        position: relative;
        border: 1px solid $borderColor;
        box-sizing: border-box;

        .trofeu {
          position: absolute;
          top: -8px;
          right: -7px;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: $corFundoPadraoDashboard;
          border-radius: 100%;
          border: 2px solid $borderColor;
          box-sizing: border-box;
          z-index: 1;
        }

        &:hover{
          border-color: $corVerdeClaro;

          .trofeu {
            border-color: $corVerdeClaro;
          }
        }
  
        .habilidade {
          font-size: 14px;
          font-weight: 500;
          color: $corBranco;
          margin: 10px 0 6px 0;
        }
  
        .posicao {
          font-size: 12px;
          color: $corValueInfoContato;
        }
      }
    }
  }

  .habilidades {
    margin-bottom: 25px;
    padding: 0 25px;
    box-sizing: border-box;

    .label-habilidades {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: $corVerdeClaro;
      font-size: 16px;
      font-weight: 600;

      svg {
        margin-right: 5px;
      }
    }

    .tags-habilidades {
      margin-top: 25px;
    }
  }

  .btn-acoes-social {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    border-top: 1px solid $borderColor;
    padding: 0 25px;
    box-sizing: border-box;

    .btn-social {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}

@media (max-width: 500px) {
  .container-perfil {
    .header {
      .card-podium {
        gap: 10px;
      }
    }
  }
}

@media (max-width: 390px) {
  .container-perfil {
    .header {
      .card-podium {
        gap: 10px;
        .top-3 {
          padding: 15px 10px;
          min-width: 100px;

          .trofeu{
            top: -12px
          }
          .habilidade {
            font-size: 12px;
          }
          .posicao {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>